import { SimplePointSymbol } from "../symbol/symbol";
import { Renderer } from "./renderer";
/**
 * 点半径渲染
 * @remarks
 * 只适用点图层
 */
export class DotRenderer extends Renderer {
    /**
     * 半径字段
     */
    get field() {
        return this._field;
    }
    /**
     * 半径字段
     */
    set field(value) {
        this._field = value;
    }
    /**
     * 根据矢量要素获取渲染符号
     * @param {Feature} feature - 矢量要素
     * @return {Symbol} 返回渲染符号
     */
    getSymbol(feature) {
        this.symbol = this.symbol || new SimplePointSymbol();
        this.symbol.radius = Number(feature.properties[this.field.name] || 0);
        return this.symbol;
    }
}
